import { Box, Grid, Stack, Typography } from "@mui/material";
// @ts-ignore
import settingsImg from "assets/images/settingsImg.svg";
import { ErrorLayout } from "./ErrorLayout";
import { Button } from "components/button";
import { useEffect } from "react";
import { sentryLogger } from "utilz";
import { debugConsole } from "utilz/helpers";
export const ErrorFallbackComponent = ({ error }: { error: Error }) => {
  useEffect(() => {
    debugConsole("ERROR FALLBACK:", error);
    if (
      error.message.includes("Failed to fetch dynamically imported") ||
      error.message.includes("Loading chunk") ||
      error.message.includes("error loading dynamically imported module")
    ) {
      window.location.reload();
    }
    sentryLogger({
      error: {
        message: `${error.message}`,
        traceId: "",
        status: 400,
      },
      // message: `${error}`,
      data: error,
      level: "error",
      functionName: "ErrorFallbackComponent",
      workflow: "common",
    });
  }, [error]);

  // if error is of chunk loading error do a page reload and donst show oops screen
  if (
    error.message.includes("Failed to fetch dynamically imported") ||
    error.message.includes("Loading chunk") ||
    error.message.includes("error loading dynamically imported module")
  ) {
    window.location.reload();
    return <></>;
  }

  return (
    <Box width={"100vw"} height={"100vh"}>
      <ErrorLayout
        errorImg={settingsImg}
        leftSide={
          <Stack
            sx={{
              maxWidth: "360px",
              gap: "16px",
            }}
          >
            <Typography variant="h3">Looks like a blip!</Typography>
            <Typography
              variant="body-large"
              sx={{
                textAlign: "justify",
              }}
            >
              Try refreshing, let’s get things back on track.
            </Typography>
            <Button
              fullWidth
              onClick={() => {
                window.location.href = "/app/home";
              }}
            >
              Back to home
            </Button>
          </Stack>
        }
      />
    </Box>
  );
};
